import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import News from './News/News'
import PositionsTable from './PositionsTable/PositionsTable'
import { useDefaultComponentTools } from '../../../../hooks/useDefaultComponentTools'
import { selectAccessToken } from '../../../../store/redusers/auth/selectors'
import { getPositionsData } from '../../../../store/redusers/positions/actions'
import {
	selectPositionsTab
} from '../../../../store/redusers/positions/selectors'
import { selectUserId } from '../../../../store/redusers/user/selectors'

let interval
const PositionsContent = ({headerHeight}) => {
	const userId = useSelector(selectUserId)
	const accessToken = useSelector(selectAccessToken)
	const positionsTab = useSelector(selectPositionsTab)
	const isNews = positionsTab === 'news'
	const {loading, setLoading, dispatch, alert, mdUp} = useDefaultComponentTools(true)
	const getDataPositions = async (loop, user, token) => {
		try {
			if(!loop) setLoading(true)
			await dispatch(getPositionsData(user, token, alert))
		} catch (e) {
			'message' in e && alert.error(e.message)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if(!userId) {
			if (interval) {
				clearInterval(interval)
			}
			return
		}
		if(!accessToken) return
		getDataPositions(false, userId, accessToken)
		interval = setInterval(() => {
			getDataPositions(true, userId, accessToken)
		}, 60000)
	}, [userId, accessToken])

	return (
		<Box sx={{height: `calc(100% - ${headerHeight + 'px'})`, overflow: 'auto',
			width: mdUp ? 'auto' : window.innerWidth}}>
			{
				userId && !isNews
					? <PositionsTable isFetchData={loading}/>
					: <News/>
			}
		</Box>
	)
}

PositionsContent.propTypes = {
	headerHeight: PropTypes.number
}

export default PositionsContent

